import Vue from 'vue';
import Vuetify from 'vuetify';
import '@/registerServiceWorker';
import VueTouch from 'vue-touch';
import gitpage from 'vue-gitpage'; // npm install vue-gitpage
import App from './App.vue';
import router from './router';
import store from './store';
import VueRouterBackButton from 'vue-router-back-button';
import VeeValidate from 'vee-validate';
import VuePageTransition from 'vue-page-transition';
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
import vueSmoothScroll from "vue-smoothscroll";
// import Prism from "prismjs";
import VuePlyr from "vue-plyr";
import AppHeader from '@/components/Header';
import AppFooter from '@/components/Footer';
import SuiVue from 'semantic-ui-vue';
import conf from '@/config/config';



//import 'vuetify/dist/vuetify.min.css';
import '@/assets/style/main.styl';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import "vue-loaders/dist/vue-loaders.css";
import "vue-plyr/dist/vue-plyr.css";
// import "vue2-animate/dist/vue2-animate.min.css";
import 'semantic-ui-css/semantic.min.css';
Vue.use(Vuetify, {
  options: {
    customProperties: true,
  },
  theme: {
    dark: '#353535',
  },
  iconfont: 'md',
});

Vue.component('app-header', AppHeader);
Vue.component('app-footer', AppFooter);

Vue.use(VuePageTransition);
Vue.use(VueRouterBackButton, { router });
Vue.use(VueTouch);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(gitpage);
Vue.use(VeeValidate);
Vue.use(require("vue-shortkey"));
Vue.use(vueSmoothScroll);
Vue.use(VuePlyr);
Vue.use(SuiVue);
// Vue.use(Prism);
Vue.filter('truncate', function (value, limit) {
  console.log(value);
  if (value instanceof Object)
    value = JSON.stringify(value);
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + '...';
  }

  return value;
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm:ss A')
  }
});

Vue.config.productionTip = false;

Vue.prototype.getTime = function () {
  var d = new Date();
  var timestring =
                ("0" + d.getHours()).slice(-2)
                + ":" + ("0" + d.getMinutes()).slice(-2)
                + ":" + ("0" + d.getSeconds()).slice(-2)
                + ":" + ("0" + d.getMilliseconds()).slice(-3);
  return timestring;
};

Vue.prototype.makeId = function(length){
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

Vue.prototype.isJson = function(str){
  try {
    JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
};

const DEFAULT_TITLE = 'Jujue';
router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
